import Immutable from 'immutable';
import { Markup } from './Markup';

export interface RawNewMarkup {
  clientGeneratedID: string;
  fileid: string;
  projectid: string;
  jsonBlob: string;
}

export interface MarkupData {
  clientGeneratedID: string;
  fileid: string;
  projectid: string;
  jsonBlob: string;
}

const defaultValues: MarkupData = {
  clientGeneratedID: '',
  fileid: '',
  projectid: '',
  jsonBlob: '',
};

export const NewMarkupFactory = Immutable.Record(defaultValues, 'NewMarkup');

export class NewMarkup extends NewMarkupFactory {
  static deserialize(rawNewMarkup: RawNewMarkup): NewMarkup {
    return new NewMarkup({
      ...rawNewMarkup,
    });
  }

  serialize(): RawNewMarkup {
    return this.toObject();
  }

  intoMarkup(): Markup {
    return new Markup({
      ...this.toObject(),
      markupid: this.clientGeneratedID,
    });
  }
}
